import React from 'react';
import { Chip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { PositionStatus } from '../../../../types/generatedTypes';

interface PositionStatusBadgeProps {
  status: PositionStatus;
}

const statusConfig: Record<
  PositionStatus,
  {
    label: string;
    color: 'success' | 'error' | 'warning' | 'info';
    icon: React.ReactElement;
  }
> = {
  matched: {
    label: 'Matched',
    color: 'success',
    icon: <CheckCircleIcon fontSize="small" />,
  },
  missing_in_illio: {
    label: 'Missing in Illio',
    color: 'error',
    icon: <ErrorIcon fontSize="small" />,
  },
  missing_in_bank: {
    label: 'Missing in Bank',
    color: 'warning',
    icon: <HelpOutlineIcon fontSize="small" />,
  },
  quantity_alert: {
    label: 'Qty Alert',
    color: 'warning',
    icon: <WarningIcon fontSize="small" />,
  },
  price_alert: {
    label: 'Price Alert',
    color: 'warning',
    icon: <WarningIcon fontSize="small" />,
  },
};

export const PositionStatusBadge: React.FC<PositionStatusBadgeProps> = ({
  status,
}) => {
  const config = statusConfig[status];

  if (!config) {
    return <Chip label={status} size="small" />;
  }

  return (
    <Chip
      icon={config.icon}
      label={config.label}
      color={config.color}
      size="small"
      sx={{
        fontWeight: 500,
        '& .MuiChip-icon': {
          marginLeft: '4px',
        },
      }}
    />
  );
};
